module.exports = __webpack_public_path__ + "static/media/om_lipshape_oval.f8202cbf.png";